module.exports = __webpack_public_path__ + "img/8.03268471.svg";